import { Link } from "react-router-dom";
import { StarRating } from "./StarRating";
import { MapPin, Calendar } from "lucide-react";

export default function JudgeCard({ judge }) {
  return (
    <Link
      to={`/judges/${judge.id}`}
      className="block bg-white gold-accent-top shadow-md hover-lift rounded-sm overflow-hidden"
      data-testid={`judge-card-${judge.id}`}
    >
      <div className="p-6">
        <h3 className="font-heading text-xl font-semibold text-navy mb-2">
          {judge.name}
        </h3>
        
        <div className="flex items-center gap-2 text-slate-600 text-sm mb-3">
          <MapPin className="w-4 h-4" />
          <span>{judge.location || "Location not specified"}</span>
        </div>

        {judge.events_judged && judge.events_judged.length > 0 && (
          <div className="flex items-center gap-2 text-slate-600 text-sm mb-4">
            <Calendar className="w-4 h-4" />
            <span>{judge.events_judged.slice(0, 2).join(", ")}</span>
            {judge.events_judged.length > 2 && (
              <span className="text-gold">+{judge.events_judged.length - 2} more</span>
            )}
          </div>
        )}

        <div className="flex items-center justify-between pt-3 border-t border-slate-100">
          <StarRating rating={judge.avg_overall || 0} size="sm" />
          <span className="text-sm text-slate-500">
            {judge.review_count || 0} {judge.review_count === 1 ? "review" : "reviews"}
          </span>
        </div>
      </div>
    </Link>
  );
}
